module.exports = __webpack_public_path__ + "green.3185c3f4.png";